var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.9987 36.6663c9.2047 0 16.6667-7.4619 16.6667-16.6666 0-9.2048-7.462-16.66669-16.6667-16.66669s-16.66667 7.46189-16.66667 16.66669c0 9.2047 7.46197 16.6666 16.66667 16.6666z",
    fillOpacity: 0.35,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.6667 27-11.6667-11.6667c-.6667-.6666-.6667-1.6666 0-2.3333s1.6667-.6667 2.3333 0l11.6667 11.6667c.6667.6666.6667 1.6666 0 2.3333s-1.6667.6667-2.3333 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 24.6667 11.6667-11.6667c.6666-.6667 1.6666-.6667 2.3333 0s.6667 1.6667 0 2.3333l-11.6667 11.6667c-.6666.6667-1.6666.6667-2.3333 0s-.6667-1.6667 0-2.3333z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6f93874e51d2eca41bd1f62a2e9d7783.svg";
export { ForwardRef as ReactComponent };